<template>
  <div>
    <vs-popup-custom
      :title="$t('request_documents') | capitalize"
      color="danger"
      :buttonCloseHidden="true"
      :active.sync="value"
      :persistent="true"
    >
      <div :id="loadingPage" class="vs-con-loading__container">
        <form class="px-2">
          <div>
            <vs-row class="mb-5">
              <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="px-2">
                <vs-row>
                  <vs-col>
                    <span class="f-bold">
                      {{ $t('document') | capitalize }}
                    </span>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col>
                    {{ data.document_name | capitalize }}
                  </vs-col>
                </vs-row>
              </vs-col>
              <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="px-2">
                <vs-row>
                  <vs-col>
                    <span class="f-bold">
                      {{ $t('frequency') | capitalize }}
                    </span>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col>
                    {{ data.frequency_name | capitalize }}
                  </vs-col>
                </vs-row>
              </vs-col>
            </vs-row>
            <!--DATES-->
            <vs-row class="mb-5">
              <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="px-2">
                <vs-row>
                  <vs-col>
                    <span class="f-bold">
                      {{ $t('start_date') | capitalize }}
                    </span>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col>
                    <vs-input
                      class="w-full"
                      type="date"
                      v-model="data.start_date"
                    />
                  </vs-col>
                </vs-row>
              </vs-col>
              <vs-col vs-xs="12" vs-sm="6" vs-lg="6" class="px-2">
                <vs-row>
                  <vs-col>
                    <span class="f-bold">
                      {{ $t('end_date') | capitalize }}
                    </span>
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col>
                    <vs-input
                      class="w-full"
                      type="date"
                      v-model="data.end_date"
                    />
                  </vs-col>
                </vs-row>
              </vs-col>
            </vs-row>
            <!---->

            <div v-if="item.frequency_id != '8'">
              <vs-row class="mb-5">
                <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="px-2">
                  <vs-checkbox v-model="data.active">
                    {{ $t('auto_generated') | capitalize }}
                  </vs-checkbox>
                </vs-col>
              </vs-row>
            </div>

            <vs-row vs-type="flex" vs-justify="center">
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-xs="12"
                vs-sm="3"
                vs-lg="3"
                class="mb-2"
              >
                <vs-button
                  class="w-full mx-2"
                  type="border"
                  color="primary"
                  @click="close"
                >
                  {{ $t('close') | capitalize }}
                </vs-button>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-xs="12"
                vs-sm="3"
                vs-lg="3"
                class="mb-2"
              >
                <vs-button
                  class="w-full mx-2"
                  type="filled"
                  color="primary"
                  :disabled="disabledSubmit"
                  @click="submit"
                >
                  {{ $t('submit') | capitalize }}
                </vs-button>
              </vs-col>
            </vs-row>
          </div>
        </form>
      </div>
    </vs-popup-custom>
  </div>
</template>
  
  <script>
import VsPopupCustom from '@/views/components/modals/VsPopupCustom.vue'
import loading from '@/mixins/Loading'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import repse from '../../requests/repse'
import moment from 'moment'
export default {
  components: {
    VsPopupCustom,
    Datepicker,
    'v-select': vSelect,
  },
  computed: {
    disabledSubmit() {
      let start_date = moment(this.data.start_date)
      let end_date = moment(this.data.end_date)
      if (start_date.isValid() && end_date.isValid()) {
        return (
          this.data.end_date <= this.data.start_date ||
          this.data.start_date === '' ||
          this.data.end_date === ''
        )
      }
      return true
    },
  },
  data() {
    return {
      data: {},
      loadingPage: 'edit-vendor-documentation-loading',
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    vendor: {
      type: Object,
      default: () => ({}),
    },
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    close: function () {
      this.$emit('input', false)
    },
    submit: function () {
      this.openLoading(this.loadingPage)
      let { documentation_id, active, document_id, start_date, end_date } =
        this.data
      repse
        .createDocumentationRequest({
          documentation_id,
          active,
          document_id,
          start_date,
          end_date,
          vendor_id: this.vendor.id,
        })
        .then((response) => {
          this.closeLoading(this.loadingPage)
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Document Updated',
          })
          this.$emit('input', false)
          this.$emit('refresh', false)
        })
        .catch((response) => {
          this.closeLoading(this.loadingPage)
          this.showValidationErrors(response)
        })
    },
  },
  mixins: [loading],
  watch: {
    value(val) {
      if (val) {
        this.data = Object.assign({}, this.item)
        this.data.active = this.data.active === '1' ? 1 : 0
        this.data.start_date = this.item.end_date !== null ? this.item.end_date : null
        this.data.end_date = null
      }
    },
  },
}
</script>
  
  <style>
.select-h > .vs__dropdown-menu {
  height: 50px;
}
</style>